import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "./InitialOrderSuccess.css";

const InitialOrderSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="order-success-container">
      <Helmet>
        <title>Order Submitted – LingoLab</title>
        <meta
          name="description"
          content="Your translation order was submitted successfully. Check your email for confirmation and next steps from LingoLab."
        />
        <meta name="robots" content="noindex, follow" />
        <link
          rel="canonical"
          href="https://lingolab.ca/initial-order-success"
        />
        <meta property="og:title" content="Order Submitted – LingoLab" />
        <meta
          property="og:description"
          content="Thank you for your order! Check your email for confirmation and next steps from LingoLab."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://lingolab.ca/initial-order-success"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@LingLabAI" />
        <meta name="twitter:title" content="Order Submitted – LingoLab" />
        <meta
          name="twitter:description"
          content="Thank you for your order! Check your email for confirmation and next steps from LingoLab."
        />
        <meta name="twitter:image" content="https://lingolab.ca/ll-X.png" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "LingoLab",
              "url": "https://lingolab.ca/",
              "logo": "https://lingolab.ca/ll-X.png",
              "sameAs": [
                "https://twitter.com/LingLabAI"
              ],
              "description": "LingoLab uses advanced AI to translate and localize your videos into 80+ languages, preserving the original voice and syncing lips for a native look.",
              "contactPoint": {
                "@type": "ContactPoint",
                "email": "support@lingolab.ca",
                "contactType": "customer support",
                "url": "https://lingolab.ca/contact"
              }
            }
          `}
        </script>
      </Helmet>
      <div
        className="order-success-card"
        role="region"
        aria-labelledby="order-success-title"
      >
        {/* Header */}
        <h2 className="order-success-title" id="order-success-title">
          Order Submitted Successfully!
        </h2>

        {/* Message */}
        <div className="order-success-message">
          <p>
            Thank you for your order. Please check your email within the next 24
            hours for our reply. If you don’t see it, kindly check your junk or
            spam folder.
          </p>
        </div>

        {/* Back to Orders Button */}
        <button
          onClick={() => navigate("/my-orders")}
          onTouchStart={() => {}}
          className="order-success-button"
          aria-label="Return to My Orders"
        >
          Back to My Orders
        </button>
      </div>
    </div>
  );
};

export default InitialOrderSuccess;
